import { render, staticRenderFns } from "./CrmGroupList.vue?vue&type=template&id=4222795b&scoped=true&"
import script from "./CrmGroupList.vue?vue&type=script&lang=ts&"
export * from "./CrmGroupList.vue?vue&type=script&lang=ts&"
import style0 from "./CrmGroupList.vue?vue&type=style&index=0&id=4222795b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4222795b",
  null
  
)

export default component.exports